var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-checkbox",class:[
    ..._vm.styles, 
    { checked: _vm.value }, 
    { disabled: _vm.disabled }
  ],on:{"click":_vm.toggleValue}},[_c('div',{staticClass:"checkbox-and-label"},[_c('div',{staticClass:"checkbox-container"},[(_vm.value === true)?[_c('img',{staticClass:"check-icon",attrs:{"src":require("../../assets/img/svgicons/check-white.svg")}})]:_vm._e()],2),(_vm.label)?[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])]:_vm._e()],2),(_vm.horizontalLabel)?_c('div',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.horizontalLabel)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }